// extracted by mini-css-extract-plugin
export var core = "Footer-module--core--340e5";
export var legal = "Footer-module--legal--8b3d4";
export var logos = "Footer-module--logos--e8521";